import type { SxStyle } from '@aibees/shared/theme';

export const root: SxStyle = {};

export const icon: SxStyle = {
  color: (p) => p.palette.primary[100],
};

export const input: SxStyle = {
  width: '100%',
  height: '100%',
  border: 'none',

  fontWeight: (p) => p.typography.fontWeightBold,
  ':focus-within': {
    border: 'none',
  },

  ':focus-visible': {
    border: 'none',
    outline: 'none',
  },

  '::placeholder': {
    color: (p) => p.palette.grey[400],
  },
};

export const searchBox: SxStyle = {
  background: (p) => p.palette.common.white,
  borderRadius: (p) => p.spacing(1),
  padding: (p) => p.spacing(1.25),
  borderWidth: '1px',
  borderColor: (p) => p.palette.primary[100],
  borderStyle: 'solid',
  flex: 1,
};

export const button: SxStyle = {
  minWidth: 0,
  width: (p) => p.spacing(6),
};
